var _defs, _polyline, _polyline2, _polyline3, _polygon, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobotHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 195.43 364.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #231f20;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-5, .cls-3 {\n        fill: #274143;\n      }\n\n      .cls-2 {\n        stroke: #274143;\n        stroke-width: 4px;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-9 {\n        fill: #737c7f;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 60.8,
    y1: 44.14,
    x2: 61.5,
    y2: 104.46,
    gradientTransform: "translate(201.81 122.43) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e79e4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#e09a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d4954b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c38c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#ad8249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#927548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#716546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4d5344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.59,
    y1: 194.86,
    x2: 223.99,
    y2: 194.86,
    gradientTransform: "translate(201.81 122.43) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#274143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#284143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2f4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3b4947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3e4a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#494f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5b584b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#73644e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7d694d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9a774d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c98f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#e99f4d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -109.69,
    y1: 194.92,
    x2: -76.84,
    y2: 194.92,
    gradientTransform: "translate(201.81 122.43) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e99f4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e79e4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e09a4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d4954b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#c38c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ad8249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#927548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#716546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4d5344"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274143"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 60.95,
    cy: 181.73,
    fx: 60.95,
    fy: 181.73,
    r: 136.25,
    gradientTransform: "translate(187.38 122.43) rotate(90) scale(1 .92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed3a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#fcd1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f5cda5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e9c6a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#d8bb9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#c2ad96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a79c8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#878985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737c7f"
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "159.93 178.12 136.03 177.88 136.03 189.17 160.4 189.17 159.06 186.98 158.75 183.53 159.06 181.08 159.93 178.12 159.06 178.12"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "118.09 151.5 117.94 215.88 122.78 215.18 128.22 212.61 132.96 207.82 135.56 201.96 136.09 196.37 136.03 177.88 136 167.88 134.79 162.94 132.55 159.25 129.41 155.52 125.99 152.99 121.96 151.5 118.09 151.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "47.73 321.43 42.68 323 33.71 325.31 24.32 326.65 13.91 327.04 -11.31 326.95 -19.21 326.06 -27.11 324.24 -33.83 321.43 -33.67 326.4 -32.33 331.68 -29.31 337.87 -25.21 343.09 -18.64 348.46 -12.32 351.7 -6.4 353.54 -.27 354.55 6.14 354.55 16.72 354.55 26.16 351.6 34.06 347.18 40.76 340.82 43.85 336.64 45.94 331.72 47.58 325.91 47.73 321.43"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "47.4 40.15 45.3 33.39 42.2 27.97 38.78 23.9 33.85 19.73 28.19 16.46 23.22 14.54 17.31 13.19 8.97 12.74 -1.93 12.99 -9.63 14.62 -16.14 17.35 -22.9 21.99 -27.94 27.41 -31.1 32.63 -33.13 38.27 -33.85 42.21 -33.96 45.36 -26.96 42.38 -17.41 40.49 -5.79 39.4 5.65 39.48 17.46 39.48 30.92 40.86 37.29 42.08 43.21 43.98 47.74 45.58 47.4 40.15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m117.61,229.16v-91.84s-.85-8.6-.85-8.6l-2.38-11.85-4.6-13.57-4.97-10.25-6.07-9.65-7.13-8.98-6.5-6.69-6.37-5.53-10.14-7.17-11.05-5.96-9.83-3.49-8.31-2.95-8.5-1.77-9.16-1.09-9.86-.29H-2.18s-11.05.33-11.05.33l-9.67,1.6-8.63,2.64-5.6,2.39-6.88,3.77-6.44,4.52-5.91,5.21-5.71,6.32-3.74,5.12-3.9,6.61-2.64,5.7-1.91,5.22-2.19,8.61-1.01,7.56-.23,11.13v15.04s0,10.62,0,10.62v2.91s0,.78,0,.78c0,.28,0,6.9,0,7.27,0,.23,0,14.57,0,15.2v22.58s0,25.83,0,25.83c0,1.86,0,3.72,0,5.58,0,11.24,0,22.49,0,33.73.33,3.99.67,7.99,1,11.98l2.08,8.81,3.36,8.85,4.28,7.96,5.31,7.43,5.36,5.88,5.29,4.69,8.85,6.08,9.89,4.77,7.59,2.48,7.85,1.61,8.95.75H1.18s10.96.02,10.96.02l10.06-.33,6.58-.73,13.91-2.98,11.78-4.18,10.57-5.21,8.37-5.28,8.08-6.26,7.4-7,8.99-10.72,5.88-9,4.54-8.72,3.94-9.84,1.99-5.6,1.34-6.04,1.45-7.27.61-8.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.41,127.87c-.24-2.78-.68-4.77-1.34-7.71-.47-2.1-1.17-5.2-2.57-9.17-.73-2.08-1.78-5.01-3.69-8.61-1.71-3.23-3.34-5.54-4.81-7.6-.8-1.13-2.11-2.97-4.02-5.25-2.64-3.14-4.89-5.3-6.26-6.6-1.08-1.02-2.84-2.69-5.37-4.7-1.67-1.33-3.41-2.72-5.93-4.25-2.44-1.49-4.35-2.35-6.82-3.47-2.53-1.14-4.5-2.03-7.27-2.91-3.23-1.02-5.73-1.45-9.06-2.01-2.43-.41-4.6-.79-7.49-1.01-3.42-.26-3.58.02-11.18,0-2.9,0-5.52-.05-8.83-.11-2.81-.05-4.21-.07-5.81-.11-3.88-.09-4.67-.14-6.37-.11-.96.02-3.39.07-5.81.34-1.79.19-5.98.77-11.07,2.57-1.81.64-5.03,1.8-8.83,4.14-2.69,1.65-4.59,3.23-5.81,4.25-1.37,1.15-3.24,2.72-5.37,5.14-.79.91-2.72,3.18-4.7,6.48-.31.52-1.65,2.8-3.02,6.04-.75,1.77-1.73,4.13-2.46,7.38-.64,2.82-.79,5-.89,6.6-.27,4.18.19,4.98.22,11.4.01,2.09-.03,3.7-.11,6.93-.09,3.65-.17,4.68-.22,7.49-.06,3.31-.02,5.68,0,7.38.02,1.62.01,6.9,0,17.44-.02,14.11-.15,12.74-.11,21.24.03,8.54.16,9.21.22,19.57.02,2.9.01,7.53,0,16.66-.03,19.57-.07,25.81-.11,29.85-.01,1.53-.1,4.3-.11,9.84,0,1.76,0,3.72.45,6.26.11.64.41,1.85,1.01,4.25.82,3.32,1.24,5,1.57,6.04.77,2.48,1.19,3.8,2.12,5.48.43.77.55.86,3.13,4.36,2.65,3.59,2.45,3.39,3.13,4.25,1.04,1.3,2.47,3.07,4.58,5.03,2.06,1.91,3.82,3.1,5.37,4.14,1.82,1.22,3.63,2.43,6.26,3.58,1.6.7,2.88,1.1,4.7,1.68,1.32.42,3.06.96,5.37,1.45.94.2,3.21.68,5.93.89,3.63.29,6.4-.01,7.38-.11,6.23-.61,6.45.26,20.24,0,2.13-.04,6.84-.15,12.86-.67,4.68-.41,6.41-.74,7.94-1.12,1.11-.28,2.53-.69,9.28-3.58,5.03-2.15,7.54-3.23,9.17-4.14,3.86-2.16,6.51-4.29,8.39-5.81,1.76-1.43,4.97-4.17,8.5-8.16,6.98-7.9,10.64-15.54,12.19-19.12,1.8-4.16,2.84-7.71,3.35-9.61.61-2.26,1.22-4.97,1.68-8.05.13-.9.67-4.66.78-10.96.05-2.93-.05-3.31-.22-10.17-.16-5.96-.25-9.54-.22-14.09.03-5.37.19-5.22.22-11.29.02-3.54-.03-4.9-.11-11.85-.08-6.3-.11-9.45-.11-11.96,0-7.57.17-8.86.22-19.45.02-3.8,0-5.94,0-6.93-.03-5.27-.12-5.44-.11-9.06,0-5.76.21-5.91,0-8.39Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 5.65,
    cy: 116.19,
    rx: 19.36,
    ry: 21.43
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 5.65,
    cy: 251.67,
    rx: 19.36,
    ry: 21.43
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m-1.25,200.61c-3.6-2.9-6.44-7.6-6.44-16.97,0-9.37,2.84-14.07,6.44-16.97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m-19.85,85.52H59.95c57.33,0,103.88,46.55,103.88,103.88v20.28c0,39.36-31.95,71.31-71.31,71.31H-52.42c-39.36,0-71.31-31.95-71.31-71.31v-20.28c0-57.33,46.55-103.88,103.88-103.88Z",
    transform: "translate(203.31 163.2) rotate(90)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m-28.98,110.86h98.07c38.51,0,69.77,31.26,69.77,69.77v28.53c0,25.66-20.83,46.49-46.49,46.49H-52.26c-25.66,0-46.49-20.83-46.49-46.49v-28.53c0-38.51,31.26-69.77,69.77-69.77Z",
    transform: "translate(203.31 163.2) rotate(90)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m113,174.49h27.87c10.1,0,18.3,8.2,18.3,18.3h-64.48c0-10.1,8.2-18.3,18.3-18.3Z",
    transform: "translate(310.58 56.7) rotate(90)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "160.59 189.17 136.48 189.17 136.48 178.12 160.7 178.12"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 169.91,
    cy: 183.64,
    r: 11.16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotHead);
export default __webpack_public_path__ + "static/media/robot_head.d17c622fb90676b5632c34c322b6bcf5.svg";
export { ForwardRef as ReactComponent };